
(function($){
    // SPREADERS
   

    if($('.JonathanGreen-spreaders').length){ 
//         function toggleDrop(){
            $(document).on("click", ".JonathanGreen-spreaders_dropdwn .JonathanGreen-spreaders_dropdwn_selected a", function(e) {
                $((".JonathanGreen-spreaders_drop")).hide();
//                 $((".JonathanGreen-spreaders_drop")).removeClass('visibleDrop');
                e.preventDefault();
                
                var dropMe = $(this).parent().siblings(".JonathanGreen-spreaders_drop");
                
                if (dropMe.hasClass("visibleDrop")) {
                     dropMe.removeClass('visibleDrop').hide();
                     $(this).removeClass("active");
                }
                else {
                     dropMe.addClass('visibleDrop').show();
                     $(this).addClass("active");
                }
            });
//         }
        $(document).mouseup(function(e) {
            var container = $(".JonathanGreen-spreaders_drop");
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) 
            {
                container.hide();
                container.removeClass('visibleDrop');
                container.siblings().find('a').removeClass('active');
            }
        });
        if($('.JonathanGreen-spreaders_content .spreaders_content.step_0').length){
            
//             toggleDrop();
            
            
            //SELECT OPTIONS AND HIDE OPTION AFTER SELECTION
            $(".JonathanGreen-spreaders_dropdwn .JonathanGreen-spreaders_drop li a").click(function(e) {
               
                e.preventDefault();
                var clickedEl = $(this)
                
                var text = $(this).html();
                var catId = $(this).attr('data-cat');
                $((".JonathanGreen-spreaders_drop")).removeClass('visibleDrop');
                $(".JonathanGreen-spreaders_dropdwn .JonathanGreen-spreaders_dropdwn_selected a span").html(text);
                clickedEl.parent().siblings().find('a').removeClass('selected');
//                 $(".JonathanGreen-spreaders_dropdwn .JonathanGreen-spreaders_drop li a").removeClass('selected');
                clickedEl.addClass('selected');
    //                     $(".JonathanGreen-spreaders_dropdwn .JonathanGreen-spreaders_dropdwn_selected a").removeClass('active');
                $(this).parent().parent().siblings('.JonathanGreen-spreaders_dropdwn_selected').find('a').removeClass('active');
                var data = {
                    categoryName: text,
                    categoryId: catId,
                    action: "spreader_cat",
                };
                
                $(".JonathanGreen-spreaders_dropdwn.product_drop").html('');
                $.ajax({
                    type: "POST",
                    url: spreader_ajax_object.ajax_url,
                    data: data,
                    beforeSend: function() {
                        $('.Jonathangren-loader').css('display','inline-block');
                        $('.spreaders_nav a.next').addClass('disabled')
                    },
                    success: function(response){
                        $('.Jonathangren-loader').hide();
                        
                        $(".JonathanGreen-spreaders_dropdwn.product_drop").html(response);
//                         toggleDrop();
                        $(".JonathanGreen-spreaders_dropdwn .JonathanGreen-spreaders_drop").hide();
                        
                        $(".JonathanGreen-spreaders_dropdwn.product_drop .JonathanGreen-spreaders_drop li a").click(function(e) {
                             $('.JonathanGreen-spreaders_dropdwn_selected a').removeClass('active');
                             $(this).parent().parent().removeClass('visibleDrop');
                            e.preventDefault()
                            var topParent = $(this).parent().parent().parent();
                            
                            var text = $(this).html();
                            var prodId = $(this).attr('data-prod');
                            var prodUrl = $(this).attr('data-url');
//                             console.log('endname')
                            $('.JonathanGreen-spreaders_ResultHeading').html(text);
                            $('.goToProduct').attr('href', prodUrl);
                            $(".JonathanGreen-spreaders_dropdwn.product_drop .JonathanGreen-spreaders_dropdwn_selected a span").html(text);
                            $(".JonathanGreen-spreaders_dropdwn .JonathanGreen-spreaders_drop").hide();
                             $(this).parent().siblings().find('a').removeClass('selected');
//                 $(".JonathanGreen-spreaders_dropdwn .JonathanGreen-spreaders_drop li a").removeClass('selected');
                            $(this).addClass('selected');
                            var selected = $(this);
                            var newData = {
                                productName: text,
                                productId: prodId,
                                action: "spreader_prod",
                            };
    //                                 $(".JonathanGreen-spreaders_product_data").text('');
                            $.ajax({
                                type: "POST",
                                url: spreader_ajax_object.ajax_url,
                                data: newData,
                                beforeSend: function() {
                                    $('.Jonathangren-loader').css('display','inline-block');
                                },
                                success: function(response){
    //                                         $(".JonathanGreen-spreaders_product_data").text(response);
                                    
//                                             console.log(response);
    //                                         console.log(parseInt(response));
                                    $('.Jonathangren-loader').hide();
                                    $('.spreaders_product_json').attr("data-spreader", "");
                                    $('.spreaders_content_buttons.companies').html("");
                                    $('.spreaders_content_buttons.select').html("");
                                    $('.spreaders_content_buttons.model').html("");
                                    $('.spreaders_content_buttons.lawn').html("");
                                    $.ajax({
                                        type: "POST",
                                        url: spreader_ajax_object.ajax_url,
                                        data: { 
                                            prdId: parseInt(response),
                                            action: "spreader_settings",
                                        },
                                        beforeSend: function() {
                                            $('.Jonathangren-loader').css('display','inline-block');
                                            
                                        },
                                        success: function(res){
//                                                     console.log($.trim(res));
                                            $('.Jonathangren-loader').hide();
                                            $('.spreaders_product_json').attr("data-spreader", res);
                                            var obj = $.parseJSON(res);
                                            var companyResult=[];
                                            var selectResult=[];
                                            var modelResult=[];
                                            var lownResult=[];
                                            if(!obj){

                                                $('.spreaders_nav a.next').addClass('disabled');
                                                
                                            }else{
                                                $('.step_0 .spreaders_nav a.next').removeClass('disabled');
                                                $(topParent).parent().next('.JonathanGreen-spreaders_mobile_acc').addClass('nextItem');
                                            }
                                            $.each(obj, function(key,value) {
//                                                         console.log(value)
                                                if($.inArray(value.company,companyResult)===-1) {
                                                    companyResult.push(value.company);
                                                }
                                                if($.inArray(value.select,selectResult)===-1) {
                                                    selectResult.push(value.select);
                                                }
                                                if($.inArray(value.model,modelResult)===-1) {
                                                    modelResult.push(value.model);
                                                }
                                                if($.inArray(value.lawn_type,lownResult)===-1) {
                                                    lownResult.push(value.lawn_type);
                                                }
                                                
                                            });

                                            function customSort(a, b) {
                                                // Define the names you want to prioritize
                                                const priorityNames = ["Jonathan Green", "Scotts"];

                                                // Check if a and b are in the priority names array
                                                const aIsPriority = priorityNames.includes(a);
                                                const bIsPriority = priorityNames.includes(b);

                                                // Compare a and b based on whether they are in the priority names array
                                                if (aIsPriority && bIsPriority) {
                                                    // If both are priority names, sort them alphabetically
                                                    return a.localeCompare(b);
                                                } else if (aIsPriority) {
                                                    // If a is a priority name, it should come before b
                                                    return -1;
                                                } else if (bIsPriority) {
                                                    // If b is a priority name, it should come before a
                                                    return 1;
                                                } else {
                                                    // If neither is a priority name, sort them alphabetically
                                                    return a.localeCompare(b);
                                                }
                                            }

                                            // Sort the array using the custom comparison function
                                            companyResult.sort(customSort);
                                            
                                            $.each( companyResult, function( i, val ) {
                                                if(companyResult[i].length){
//                                                     console.log(companyResult[i].length)
                                                    $('.spreaders_content_buttons.companies').append('<span class="JonathanGreen-spreaders-checkbox step_1" data-company="'+companyResult[i]+'" data-step="step_1"><span class="jg_s_inner">'+companyResult[i]+'</span></span>');
                                                }
                                                
                                            })
                                            
                                            $.each( selectResult, function( i, val ) {
//                                                 console.log(val)
//                                                 console.log(selectResult[i])
                                                if(selectResult[i].includes("'")){
                                                     selectResult[i].replace("'", "\'");
                                                }
                                               
                                                
                                                $('.spreaders_content_buttons.select').append('<span class="JonathanGreen-spreaders-checkbox step_2" data-type="' + selectResult[i] + '" data-step="step_2"><span class="jg_s_inner">'+selectResult[i]+'</span></span>');
                                            })
                                            
                                            $.each( modelResult, function( i, val ) {
                                                if(modelResult[i].includes("'")){
                                                     modelResult[i].replace("'", "\'");
                                                }
                                               
                                                
                                                $('.spreaders_content_buttons.model').append('<span class="JonathanGreen-spreaders-checkbox step_3" data-model="' + modelResult[i] + '" data-step="step_3"><span class="jg_s_inner">'+modelResult[i]+'</span></span>');
                                            })
                                                
                                            $.each( lownResult, function( i, val ) {
                                                    $('.spreaders_content_buttons.lawn').append('<span class="JonathanGreen-spreaders-checkbox step_4" data-lawn="'+lownResult[i]+'" data-step="step_4"><span class="jg_s_inner">'+lownResult[i]+'</span></span>');
                                            })
                                        }
                                    })
                                }
                            });
                        });
                    },

                });
            }); 
        }
    
     
        var back =$(".JonathanGreen-spreaders_wrapp .prev");
        var next = $(".JonathanGreen-spreaders_wrapp .next");
        var steps = $(".JonathanGreen-spreaders_wrapp .spreaders_sidebar.step");
        var stepsInner = $(".JonathanGreen-spreaders_wrapp .spreaders_content.step");
        var stepsInnerLast = $(".JonathanGreen-spreaders_wrapp.resultStep");
        var obj;
        
        var jsonTest = $('.JonathanGreen-spreaders_content .spreaders_content_inner').attr('data-spreader');
//         console.log(jsonTest)
        if(jsonTest){
            obj = $.parseJSON(jsonTest);
        }else{
//             var jsonTest2 = $('.JonathanGreen-spreaders_content .spreaders_product_json').attr('data-spreader');
//             console.log('jsonTest2')
//             console.log(jsonTest2)
        }
        
//         console.log($(steps).length)
        var dataCompany = [];
        var dataType = [];
        var dataModel = [];
        var lawnType = [];
        var lastStep;
            
        if($(steps).length > 5){
            lastStep = 4;
        }else {
            lastStep = 3;
        }
        $('.stepCounter > span').text(1+'/'+(lastStep+1));
        
        if ($(window).width() < 1025) {
            var animTime = 300,
            clicked = false;
//             $(".JonathangreenProductAccordion-main").each(function () {
//                 $(this).find(".JonathangreenProductAccordion-content").css("height", 0);
            next.each( function( i ) {
                $(this).bind("click", function(e) { 
                    var clickedNext = $(this);
                    e.preventDefault();
                    $(this).addClass('disabled');
                    $(this).hide();
                    $(this).parent().parent().next('.JonathanGreen-spreaders_mobile_acc').addClass('itemDone')
                    $.each( stepsInner, function( i ) {
                        
                        $(this).parent().parent().addClass('done');
                        if (!$(stepsInner[i]).hasClass('current') && !$(stepsInner[i]).hasClass('done')) {
                            
                            $(stepsInner[i]).addClass('current').slideDown();
                            $(stepsInner[i]).find('.stepCounter > span').text((i+1)+'/'+(lastStep+1));
//                             console.log($(stepsInner[i]))
                            var scrollTo;
                            if(clickedNext.hasClass('last-step')){
                                scrollTo = $(".JonathanGreen-spreaders_wrapp .spreaders_content[data-id='result']").offset().top - 130
                            }else {
                                scrollTo = $(stepsInner[i]).offset().top - 200
                            }
                            $('html, body').animate({
                                scrollTop: scrollTo
                            }, 800);
                            return false;
                        }else {
//                             console.log('sss')
                             $('.spreaders_nav a.next').addClass('disabled');
                        }
                        if(i == lastStep) {
                            $(this).closest(".JonathanGreen-spreaders_wrapp").addClass('resultStep');
//                             $('html, body').animate({
//                                 scrollTop: $(this).closest(".JonathanGreen-spreaders_wrapp").offset().top - 100
//                             }, 800);
                        }
                    })
                    
                });
            });
//             back.bind("click", function(e) { 
//                 e.preventDefault();
//                 var clickedBack = $(this);
//     //             $('.spreaders_nav a.next').addClass('disabled');
//                 $.each( stepsInner, function( i ) {
// //                     console.log($(stepsInner[i]))
//                     if ($(stepsInner[i + 1]).hasClass('current')) {
// //                         console.log($(stepsInner[i-1]))
//                         $('.stepCounter > span').text((i+1)+'/'+(lastStep+1));
//                         var scrollTo;
//                         scrollTo = $(stepsInner[i]).offset().top - 200
//                         $('html, body').animate({
//                             scrollTop: scrollTo
//                         }, 800);
//                             return false;
//                         return false;
//                     }
// //                     if(i != lastStep) {
// //                         $(this).closest(".JonathanGreen-spreaders_wrapp").removeClass('resultStep');
// //                     }
//                 })		
//             });
        } else {
            next.bind("click", function(e) { 
                e.preventDefault();
//                 $(this).addClass('disabled');
                $.each( steps, function( i ) {
                    
                    if (!$(steps[i]).hasClass('current') && !$(steps[i]).hasClass('done')) {
                        $(steps[i]).addClass('current');
    //                     console.log(i);
                        
                        $('.stepCounter > span').text((i+1)+'/'+(lastStep+1));
                        $(steps[i - 1]).removeClass('current').addClass('done');
                        var stepsLeft = 100*parseInt(i);
//                         console.log(stepsInner[i])
                        $('.spreaders_content_inner').css('height', $(stepsInner[i]).height() + 10);
                        $(stepsInner[i]).addClass('current').animate({"left":"-"+stepsLeft+"%"},700);
                        $(stepsInner[i - 1]).removeClass('current').addClass('done').animate({"left":"-"+stepsLeft+"%"},700);
                        return false;
                    }
    //                 console.log(i)
    //                 if(i === 0 && $(stepsInner[0]).hasClass('step_0')) {
    //                     var jsonTest2 = $('.JonathanGreen-spreaders_content .spreaders_product_json').attr('data-spreader');
    //                     
    //                     console.log(jsonTest2)
    //                     obj = $.parseJSON(jsonTest2);
    //                 }
                    
                    
                    if(i == lastStep) {
                        $(this).closest(".JonathanGreen-spreaders_wrapp").addClass('resultStep');
                    }
                })
                
            });
            
            back.bind("click", function(e) { 
                e.preventDefault();
    //             $('.spreaders_nav a.next').addClass('disabled');
                $.each( steps, function( i ) {
                    if ($(steps[i]).hasClass('done') && $(steps[i + 1]).hasClass('current')) {
                        $(steps[i + 1]).removeClass('current');
                        $(steps[i]).removeClass('done').addClass('current');
                        $('.stepCounter > span').text((i+1)+'/'+(lastStep+1));
                        var stepsRight = 100*parseInt(i);
                        $('.spreaders_content_inner').css('height', $(stepsInner[i]).height());
                        $(stepsInner[i + 1]).removeClass('current').animate({"left":"-"+stepsRight+"%"},700);
                        $(stepsInner[i]).removeClass('done').addClass('current').animate({"left":"-"+stepsRight+"%"},700);
                        return false;
                    }
                    if(i != lastStep) {
                        $(this).closest(".JonathanGreen-spreaders_wrapp").removeClass('resultStep');
                    }
                })
            });
        }
        
        
        

        $(('.spreaders_nav a.next')).addClass('disabled')
        $(document).on("click",".JonathanGreen-spreaders-checkbox", function(){
            
            $(this).parent().parent().next('.JonathanGreen-spreaders_mobile_acc').addClass('nextItem');
            $(this).parent().siblings('.spreaders_nav').find('a').removeClass('disabled')
            var currentDataStep = $(this).attr('data-step');
//             console.log(currentDataStep);
//             $('.spreaders_nav a.next').removeClass('disabled');
            if($('.JonathanGreen-spreaders_content .spreaders_product_json').length){
                var jsonTest2 = $('.JonathanGreen-spreaders_content .spreaders_product_json').attr('data-spreader');
                obj = $.parseJSON(jsonTest2);
                // console.log(obj)
            }

            if(currentDataStep == 'step_1'){
                
                if($(this).parent().hasClass('visited')){
//                     console.log('zzzz1')
                    dataCompany = [];
                    dataSelect = [];
                    dataType = [];
                    dataModel = [];
                    lawnType = [];
                    $(".JonathanGreen-spreaders-checkbox.step_2").hide().removeClass('active-box');
                    $('.JonathanGreen-spreaders-checkbox.step_2').removeClass('selected');
                }
            }else if(currentDataStep == 'step_2'){
                if($(this).parent().hasClass('visited')){
//                     console.log('zzzz2')
                    dataSelect = [];
                    dataType = [];
                    dataModel = [];
                    lawnType = [];
                    $(".JonathanGreen-spreaders-checkbox.step_3").hide().removeClass('active-box');
                    $('.JonathanGreen-spreaders-checkbox.step_3').removeClass('selected');
                }
            }else if(currentDataStep == 'step_3'){
                if($(this).parent().hasClass('visited')){
                    dataProject = [];
                    dataModel = [];
                    lawnType = [];
//                     console.log('zzzz3')
                    $(".JonathanGreen-spreaders-checkbox.step_4").hide().removeClass('active-box');
                    $('.JonathanGreen-spreaders-checkbox.step_4').removeClass('selected');
                }
            } 
            else if(currentDataStep == 'step_4'){
                if($(this).parent().hasClass('visited')){
                    lawnType = [];
                    dataModel = [];
    //                 $(".JonathanGreen-spreaders-checkbox.step_4").hide(); 
//                     console.log('zzzz4')
                }
            }
            
            
            var cmp =  $(this).attr('data-company');
            var typ =  $(this).attr('data-type');
            var mod =  $(this).attr('data-model');
            var lwn =  $(this).attr('data-lawn');
            var res =  $(this).attr('result');
            
            $.each(obj, function(key,value) {
                if(value.company == cmp ){

                    // $('.JonathanGreen-spreaders-checkbox.step_2').css('display','none').removeClass('active-box');
                    $(".JonathanGreen-spreaders-checkbox.step_2[data-type='" + value.select + "']").css('display','inline-block').addClass('active-box');
                    dataCompany.push(value);
                }
            });
            // console.log(dataCompany)
            if(!$.isEmptyObject( dataCompany )){
                $.each(dataCompany, function(key,val) {
                    if(val.select == typ ){
                        var $str = val.model.toString();
//                         console.log($str)

                        if ($str.includes("'") ) {
//                             $str.replace("^\\'$", "'");
                            $str.replace("'", "\'");
//                             console.log($str)
                        }
//                         console.log('$str')
//                         console.log($str)

                        $('.JonathanGreen-spreaders-checkbox.step_3[data-model="' + val.model + '"]').css('display','inline-block').addClass('active-box'); 
                        dataType.push(val);
                    }
                }); 
//             console.log('dataType')
//             console.log(dataType)
            }
            if(!$.isEmptyObject( dataType )){
                $.each(dataType, function(key,val1) {
                    if(val1.model == mod ){
                        // $('.JonathanGreen-spreaders-checkbox.step_4').css('display','none').removeClass('active-box');
                        $(".JonathanGreen-spreaders-checkbox.step_4[data-lawn='" + val1.lawn_type + "']").css('display','inline-block').addClass('active-box'); 
                        lawnType.push(val1);
                    }
                }); 
            }
            
             if(!$.isEmptyObject( lawnType )){
                $.each(lawnType, function(key,val2) {
                    if(val2.lawn_type == lwn ){
                       dataModel.push(val2);
                    }
                    
                }); 
            }
//             console.log(lawnType)
            if(!$.isEmptyObject( dataModel )){
                $.each(dataModel, function(key,val) {
//                     console.log(val.result)
                    if( val.result.length > 4){
                        $height = '157px';
                        $width = '157px';
                    }else {
                        $height = '127px';
                        $width = '127px';
                    }
                    $('.JonathanGreen-spreaders-avatar').css({
                        'height': $height,
                        'width': $width
                    })
                    $('.JonathanGreen-spreaders_ResultSetting > span').text(val.result);
                    var stripped;
                    if(val.result.indexOf("Apply twice at this setting")>0){
                        stripped = val.result.split('Apply twice at this setting');
                        strippedResult = stripped[0]
                    }else if(val.result.indexOf("Apply twice")>0){
                        stripped = val.result.split('Apply twice');
                        strippedResult = stripped[0]
                    }else {
                        strippedResult = val.result;
                    }
                    $('.JonathanGreen-spreaders-avatar > span ').text(strippedResult);
                }); 
            }
//              console.log(dataModel)
            if(currentDataStep == 'step_1'){
                $(this).parent().addClass('visited');
                $('.JonathanGreen-spreaders-checkbox.step_1').removeClass('selected');
            }else if(currentDataStep == 'step_2'){
                $(this).parent().addClass('visited');
                $('.JonathanGreen-spreaders-checkbox.step_2').removeClass('selected');
            }else if(currentDataStep == 'step_3'){
                $(this).parent().addClass('visited');
                $('.JonathanGreen-spreaders-checkbox.step_3').removeClass('selected');
            }else if(currentDataStep == 'step_4'){
                $(this).parent().addClass('visited');
                $('.JonathanGreen-spreaders-checkbox.step_4').removeClass('selected');
            }
            $(this).addClass('selected');
        });
        $('.JonathanGreen-spreaders_wrapp .start_over').click(function(e){
            e.preventDefault();
            dataCompany = [];
            dataSelect = [];
            dataType = [];
            dataModel = [];
            lawnType = [];
            $('.JonathanGreen-spreaders-checkbox.step_2').css('display','none').removeClass('active-box');
            $('.JonathanGreen-spreaders-checkbox.step_3').css('display','none').removeClass('active-box');
//             console.log('ssss');
//             $('.JonathanGreen-spreaders_wrapp .spreaders_content_inner').css('height', 'auto');
            $('.spreaders_nav a.next').addClass('disabled');
            $('.JonathanGreen-spreaders-checkbox').parent().removeClass('visited');
            $('.JonathanGreen-spreaders-checkbox').removeClass('selected');
            $(steps).removeClass('current').removeClass('done');
            $(stepsInner).removeClass('current').removeClass('done');
            $(steps[0]).addClass('current');
            $(stepsInner).css("left","auto");
            $(stepsInner[0]).addClass('current');
            if ($(window).width() >= 1025) {
//                 console.log($('.spreaders_content.step.step_1').height())
                $('.spreaders_content_inner').css('height', 'auto');
            }
            $('.JonathanGreen-spreaders_wrapp').removeClass('resultStep');
            if($('.goToProduct').length){
                $('.goToProduct').attr('href', '#');
            }
            $('.stepCounter > span').text(1+'/'+(lastStep+1));
            $('.JonathanGreen-spreaders_dropdwn.product_drop').html('');

            $(".JonathanGreen-spreaders_dropdwn .JonathanGreen-spreaders_dropdwn_selected a span").html("Please select");
            $(".JonathanGreen-spreaders_dropdwn .JonathanGreen-spreaders_dropdwn_selected a").click(function(e) {
                e.preventDefault();

                $(this).addClass("active");
                $(this).parent().siblings(".JonathanGreen-spreaders_drop").show();
            });
            if ($(window).width() < 1025) {
                $(".JonathanGreen-spreaders_wrapp .spreaders_content.step").not(':first').slideUp();
                $(".JonathanGreen-spreaders_wrapp .next").show();
            }


        })
    }
})(jQuery); 
